export const blockIconsAudioandvideoSkipPreviousNew = (
	<span className='material-symbols-outlined'>skip_previous</span>
);
